import type { ReportDefinition, NotificationRule, NotificationLog } from '../model/reportSchema';

/**
 * GET /api/reports/definitions — каталог отчётов. Бэкенд: id, title, module.
 * badge_variant — фронтовая логика.
 */
export const reportDefinitions: ReportDefinition[] = [
  { id: 1, title: 'Список непрошедших медосмотры', module: 'Медосмотры' },
  { id: 2, title: 'План-график медосмотров', module: 'Медосмотры' },
  { id: 3, title: 'Итоги медосмотров за период', module: 'Медосмотры' },
  { id: 4, title: 'Сводка по обучению за период', module: 'Обучение' },
  { id: 5, title: 'Матрица обучения по профессиям', module: 'Обучение' },
  { id: 6, title: 'Сводный отчёт СОУТ', module: 'СОУТ' },
  { id: 7, title: 'Карты рисков и мероприятия ОПР', module: 'ОПР' },
  { id: 8, title: 'Потребность в СИЗ по профессиям', module: 'Нормы СИЗ' },
  { id: 9, title: 'Реестр НПА и локальных документов', module: 'Документы' },
];

/** GET /api/reports/notification-rules — правила уведомлений. Бэкенд: template_text с плейсхолдерами {сотрудник}, {дата}. */
export const notificationRules: NotificationRule[] = [
  {
    id: 1,
    event: 'Истечение медосмотра',
    daysBefore: '30, 14, 7',
    channel: 'Email',
    recipient: 'Спец. по ОТ, рук. подразд.',
    templateText:
      'Уважаемые коллеги! Напоминаем: у {сотрудник} истекает срок периодического медосмотра ({дата}). Просьба организовать прохождение.',
  },
  {
    id: 2,
    event: 'Истечение обучения',
    daysBefore: '90, 30',
    channel: 'Email',
    recipient: 'Спец. по ОТ',
    templateText: 'Обучение / проверка знаний по ОТ у {сотрудник} истекает {дата}. Запланируйте обучение.',
  },
  {
    id: 3,
    event: 'Пересмотр карты СОУТ',
    daysBefore: '90, 30',
    channel: 'Email',
    recipient: 'Спец. по ОТ',
    templateText: 'Требуется пересмотр карты СОУТ для рабочего места {рабочее_место}. Срок: {дата}.',
  },
  {
    id: 4,
    event: 'Завершение стажировки',
    daysBefore: '3, 1',
    channel: 'Email',
    recipient: 'Мастер, спец. по ОТ',
    templateText: 'Стажировка сотрудника {сотрудник} завершается {дата}. Подготовьте допуск к самостоятельной работе.',
  },
  {
    id: 5,
    event: 'Просрочка мероприятия ОПР',
    daysBefore: '0',
    channel: 'Email',
    recipient: 'Ответственный',
    templateText: 'Мероприятие ОПР «{мероприятие}» просрочено. Ответственный: {ответственный}.',
  },
  {
    id: 6,
    event: 'Истечение срока СИЗ',
    daysBefore: '30, 7',
    channel: 'Email',
    recipient: 'Спец. по ОТ, кладовщик',
    templateText: 'По сотруднику {сотрудник} истекает срок носки СИЗ: {наименование}. Дата: {дата}.',
  },
  {
    id: 7,
    event: 'Пересмотр карты ОПР',
    daysBefore: '90, 30',
    channel: 'Внутренние',
    recipient: 'Спец. по ОТ',
    templateText: '[Внутреннее] Карта ОПР «{карта}» требует пересмотра до {дата}.',
  },
];

/** GET /api/reports/notification-logs — журнал уведомлений. Бэкенд: date ISO; status ok/err. */
export const notificationLogs: NotificationLog[] = [
  {
    id: 1,
    date: '28.04.2026 09:01',
    event: 'Медосмотр просрочен — Петров А.В.',
    recipient: 'p.ivanova@smz.ru',
    status: 'ok',
  },
  {
    id: 2,
    date: '27.04.2026 09:01',
    event: 'Обучение истекает — 8 сотрудников',
    recipient: 'p.ivanova@smz.ru',
    status: 'ok',
  },
  { id: 3, date: '25.04.2026 09:01', event: 'СОУТ истекает — РМ-047', recipient: 'p.ivanova@smz.ru', status: 'err' },
];
